// External Imports
import { h } from 'preact';
import { Button, NavBarLink, NavBarWrapper, pxToRem, styled } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import { DisplayLanguage } from '../DisplayLanguage/DisplayLanguage';
import { useStore } from '../../state/context';
import babbelLiveLogo from '../../assets/images/babbel-live-logo.webp';

// Local Variables
const desktopBreakpoint = parseInt(tokens.viewports.breakpoints.small, 10);
const NavBarMenu = styled.ul`
  display: flex;
  flex-flow: column;
  padding: 0;
  list-style: none;
  @media (min-width: ${pxToRem(desktopBreakpoint)}) {
    flex-flow: row;
    gap: ${pxToRem(24)};
  }
`;
const NavBarMenuItem = styled.li`
  width: 100%;
  display: flex;
  @media (min-width: ${pxToRem(desktopBreakpoint)}) {
    width: auto;
  }
`;
// Component Definition
function Header() {
  const state = useStore();
  const { forBusinessesLink, getDropdownLink, loginLink, t } = state;

  return (
    <NavBarWrapper
      fullWidthSections
      logoUrl={babbelLiveLogo}
      rightAlignedItems={
        <NavBarMenu>
          <NavBarMenuItem>
            <NavBarLink href={forBusinessesLink} underlined={false}>
              {t.nav.b2b}
            </NavBarLink>
          </NavBarMenuItem>
          <NavBarMenuItem>
            <DisplayLanguage />
          </NavBarMenuItem>
          <NavBarMenuItem>
            <NavBarLink href={loginLink} underlined={false}>
              {t.nav.login}
            </NavBarLink>
          </NavBarMenuItem>
          <NavBarMenuItem>
            <Button as="a" fullWidth href={getDropdownLink()}>
              {t.cta}
            </Button>
          </NavBarMenuItem>
        </NavBarMenu>
      }
      toggleLabels={{
        close: 'Close menu',
        open: 'Open menu',
      }}
    />
  );
}

export { Header };
